import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;
const BadgeIcon = styled.img`
  width: 16px;
  height: 8px;
`;
const Message = styled.p`
  color: ${({
  theme
}) => theme.color.content10};
  font-size: 14px;
  font-weight: 700;
`;
const Badge = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  display: flex;
  height: 24px;
  padding-block: 0;
  padding-inline-start: 4px;
  padding-inline-end: 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background-color: ${({
  theme
}) => theme.color.surface4};
`;
interface Props {
  className?: string;
  children?: string;
}
export default function SubscribePlanStatus({
  children,
  ...props
}: Props) {
  const {
    t
  } = useTranslation();
  return <Container {...props} data-sentry-element="Container" data-sentry-component="SubscribePlanStatus" data-sentry-source-file="index.tsx">
      <Message data-sentry-element="Message" data-sentry-source-file="index.tsx">{children}</Message>
      <Badge data-sentry-element="Badge" data-sentry-source-file="index.tsx">
        <BadgeIcon src='/vividi/images/icons/icUnlimited.png' alt='unlimited' data-sentry-element="BadgeIcon" data-sentry-source-file="index.tsx" />
        <Message data-sentry-element="Message" data-sentry-source-file="index.tsx">{t('vividi_mirror_unlimited_logo_text')}</Message>
      </Badge>
    </Container>;
}